//import { HubConnectionBuilder } from '@aspnet/signalr';

//(($) => {
//  var hub = new HubConnectionBuilder().withUrl("/statusMessageHub").build();

//  hub.on('StatusMessage', (message: string) => {
//    console.log(message);
//  });

//  var clientId = '';
//  hub.start()
//    .then(() => {
//      const matches = (hub as any).connection.transport.webSocket.url.match(/.*=(.*)/);
//      clientId = matches[1];

//      $.holdReady(false);
//    })
//    .catch((err: any) => console.log(err));

//  // Configuration meant to add the client id to all requests so that we can send messages back
//  // down to this client instead of all of them
//  $(document)
//    .ajaxSend(function (event, xhr, options) {
//      xhr.setRequestHeader('HubConnectionId', clientId);
//    });

//  // Hold the ready state so that we can finish connecting to the signalr socket so that messages can be sent back and forth
//  $.holdReady(true);
//})($);

export {};